var _excluded = ["children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import Menu from './Menu';
import NoAutocompleteResults from './NoAutocompleteResults';

/**
 * This menu adds the empty state for an autocomplete dropdown when no results are found
 */
var AutocompleteMenu = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var content = React.Children.toArray(children).length > 0 ? children : /*#__PURE__*/React.createElement(NoAutocompleteResults, null);
  return /*#__PURE__*/React.createElement(Menu, _extends({
    ref: ref
  }, props), content);
});
AutocompleteMenu.displayName = 'AutocompleteMenu';
AutocompleteMenu.propTypes = Menu.propTypes;
export default AutocompleteMenu;
//# sourceMappingURL=AutocompleteMenu.js.map